export default {
  menu: {
    bussinesscooperator: '成为ChrgiePower合作伙伴',
    advertisingplatform: '人才招聘',
    contactUS: '联系我们',
    faq: '常见问题',
    serviceIntro: '关于我们',
    usage: '使用方法',
    fee: '收费方式',
    brands: '合作品牌'
  },
      aboutUs: {
    title: '    香港拾壹新启点科技有限公司——智创共用能源生态，赋能城市活力续航作为香港共享经济领域的革新力量，拾壹新启点科技深耕智能充电解决方案，以「全场景覆盖+极速充电科技」为核心，构建全港规模最大的便捷共享能源服务网络。我们通过自主研发的第四代智能共用充电设备，为便利店、商超综合体、酒店食肆、文旅地标及公共交通枢纽等200+场景提供24小时不间断的充电支持，日均服务超10万人次，让城市永不断电。公司成立之初，以成为香港最大的共享经济企业为宏伟目标。为了实现这一目标，公司不断加大投入，提升充电的技术标准、扩大充电的覆盖范围、提高用户与客户的服务标准。致力于为广大市民群众提供便捷、高效、可靠的充电服务，把超大容量与超快充电技术覆盖全港。公司的口号是“让生活充满电”。这不仅体现了公司对产品的期许，也代表了我们对社会的责任。我们相信，科技可以改变生活，让生活更加美好。公司于2023年入驻香港共享充电宝品牌，于2025年初正式推出超大容量、超级快充产品。',
    // intro: '这里是中文的介绍。'
  },
  bussinesscooperator: {
    // title: '成为ChrgiePower合作伙伴',
    // content: '这里是最新的成为ChrgiePower合作伙伴。'
      title: '',
    content: ''
  },
    faq: {
    title: '常见问题',
    questions: [
      {
        q: '无法在手机地图上查看到附近的门店？',
        a: '产生这种情况可能的原因有：用户手机设备GPS未开启、系统权限未开启、网络状态不佳、获取定位信息超时等。建议您优先检查系统权限、网络状态并尝试删除小程序重新进入，在小程序申请定位时选择“允许访问定位”，并确认微信、支付宝等应用本身有定位权限；同时确认用户所在地是否是商场地下等非开阔地区，如果在室内也可能出现定位失败的问题。权限和网络调整好后，请您手动调整定位，缩放地图，进而找到可归还点位。',
      },
      {
        q: '借用了移动电源后可以在其他地方还吗？',
        a: '可在香港地区任一有CHRGIE POWER的充电机柜点位处归还',
      },
       {
        q: '显示租借成功，但未弹出移动电源？',
        a: '请留意机柜左右侧弹出的移动电源，如果移动电源未弹出，请联系客服人员协助处理。',
      },
       {
        q: '如何租用移动电源？',
        a: '首先，您必须在 App Store 或 Google Play 上下载 xxx 应用程序。您需要创建或登录 xxx 账户，提供有效的手机号码或电子邮件，并输入我们发送到该号码或电子邮件的四位一次性密码短信。点击应用程序主屏幕上的 “扫码租借”，扫描充电机柜前的二维码。如果您正在寻找站点，请查看应用程序中的地图。',
      },
       {
        q: '如果我无法从站点取出一个移动电源，我该怎么办？',
        a: '请联系应用程序内的支持团队，客服人员协助处理。',
      },
       {
        q: '如果电站空了，我该怎么办？',
        a: '如果站点无可租借移动电源，请通过应用程序查找下一个较近的站点。',
      },
       {
        q: '如何归还移动电源？',
        a: '归还时，只需将移动电源推入任意站点的空槽即可。将其完全推入，直到发出咔嗒声，然后等待应用程序显示您的租赁记录，如果没有，请联系应用程序内的支持人员。',
      },
       {
        q: '如果要归还的站点已满，我该怎么办？',
        a: '如果站点已满，要将移动电源放回站点，请通过应用程序查找下一个较近的站点。',
      },
       {
        q: '如果充电机柜没有弹出，但运行程序开始运行，我该怎么办？',
        a: '首先刷新订单页面，检查订单是否已结束。如果订单仍在运行，请选择正在运行的订单上的 “客户服务 ”按钮，然后按照提示一步步操作。(您需要提交一张清晰的充电柜正面照片，并清楚标明二维码）。订单将结束，您可以重新开始租赁。',
      },
        {
        q: '如果我已经退还了移动电源，但订单仍在运行，我该怎么办？',
        a: '您首先需要确保归还的充电机柜处于通电状态。其次检查并确认充电宝已正确插入。刷新订单页面，检查订单页面是否停止（网络不佳可能会延迟响应）。如果订单仍在运行，请点击主页上的 “客户服务 ”按钮，并按步骤说明操作。(请通过应用程序报告充电机柜故障，或联系应用程序内支持团队。',
      },
      {
        q: '如何报告充电机柜故障？',
        a: '请通过应用报告充电机柜故障，或联系应用内支持团队。',
      },
      {
        q: '如果我租用了移动电源，但没有数据线，该怎么办？',
        a: '如果没有电源线，请先归还充电机柜，并在应用程序提示内报告。 您将不会为此支付租金。然后请继续租用另一个移动电源。',
      },
       {
        q: '我的移动电源无法为手机充电，我该怎么办？',
        a: '确保数据线正确插入设备。我们建议您取下厚厚的手机壳，让数据线完全插入。如果仍然无法充电，请将移动电源放回充电机柜，并通过应用内支持与我们联系。',
      },
        {
        q: '如果我丢失/未归还移动电源，会发生什么情况？',
        a: '您需要支付违约金。价格计划显示在主页横幅上。',
      },
       {
        q: '如何检查移动电源的电量？',
        a: '只需按下电源箱正面的按钮，LED 指示灯就会显示电量水平。',
      },
          {
        q: '一个移动电源的租金是多少？',
        a: ' 一般价格计划显示在主页横幅上。扫描充电机柜二维码后也会显示价格计划。',
      },
         {
        q: '如何支付租赁费用？',
        a: ' 首次登录后，系统会提示您添加一张有效的信用卡/借记卡。归还至充电机柜时，租金将自动从默认卡中扣除。如果付款失败，再次登录时主页上将显示未付款订单，您必须手动完成付款才能恢复正常服务。',
      },
         {
        q: '如何查看我的移动电源使用了多长时间以及花费了多少钱？',
        a: '一旦开始租用移动电源，应用程序中就会显示这些信息。时间和累积的确切费用都会显示出来。',
      },
         {
        q: '如果我被多收了费用，我该怎么办？',
        a: '请联系应用内支持团队，我们将很乐意为您提供帮助。',
      },
         {
        q: '为什么我需要使用信用卡/借记卡？',
        a: '您需要使用信用卡/借记卡作为安全保障，以鼓励公平、安全地使用我们的服务。',
      },
      {
        q: '如何退还押金？',
        a:'1.如移动电源已归还成功，订单状态已更新。2.进入 “钱包页面”，点击 “退款 ”按钮并提交。3.退款将在3-6个工作日返还到您充值时使用的同一银行账户。'
      },
       {
        q: '如果我收到退款，需要多长时间？',
        a:'在退款撤销的情况下，客户不会在对账单上看到退款信用额度--您只会看到原始授权在几天后从对账单上完全删除。没有付款，也没有退款。整个交易就好像从未发生过一样。您的银行应该可以向他们确认这一点。根据发卡行的不同，原始费用会在 7 个工作日后从待处理费用中消失。'
         },
          {
        q: '我没有收到应用程序的验证码，我该怎么办？',
        a:'这取决于您的手机是否有足够的移动信号来接收。您可能需要进入信号较好的范围。否则，请确保您输入了正确的手机号码。如果您使用电子邮件，请记得检查垃圾邮件。如果其他方法都无效，请联系应用内支持团队，我们将帮助您设置账户。'
         },
          {
        q: '应用程序无法使用， 我该怎么办？',
        a:'您可以先尝试刷新应用程序。如果还不行，请删除并重新安装应用程序。如果还不行，请联系支持团队，我们会帮您解决！'
      },
      {
        q: '如何注销用户？',
        a:'打开CHRGIE POWER应用程序，转到“帐户设置”→选择“注销”→同意“用户协议”，单击“确认删除”，按照提示确认删除。'
          }
      // 其他问题和答案...
    ]
  }
}
